/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * February 2022
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import NbioApi from "../../lib/api/NbioApi";
import BootstrapTable from "react-bootstrap-table-next";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from 'react-bootstrap/Spinner'

//components
import NPPaginator from "../ui/NPPaginator";


class AdsTable extends React.Component{
    constructor(p) {
        super(p);
        this.state = {
            ads:[],
            isLoading:true,
            pages:1,
            currentPage:1,
        }
        this.loadAds   = this.loadAds.bind(this);
    }

    componentDidMount() {
        this.loadAds();
    }

    loadAds(){
        const pageSize=25;
        this.setState({isLoading:true});
        NbioApi.ads.getAds(this.state.currentPage,pageSize).then(res => {
            console.log(res.data);
            this.setState({
                ads:res.data.ads,
                isLoading:false,
                pages:res.data.pages
            });
        }).catch((ex) =>{
            this.setState({
                ads:[],
                isLoading:false,
                pages:1,
            });
        })
    }

    onPageChanged(page){
        this.setState({currentPage:page},() =>{
            this.loadAds();
        })
    }

    render(){
        const columns = [
            {
                dataField: 'image',
                text: 'Imagen',
                formatter:(value,row)=>{
                    return(
                       <a href={`/ads/${row._id}`}><img src={value} height={75} width={75}/></a>
                    )
                },
                headerStyle:(row,rowIndex) =>{
                    return {width: '80px'}
                },
            },
            {
                dataField: 'name',
                text: 'Nombre',
            },
            {
                dataField: 'link',
                text: 'Link del anuncio',
            },
            {
                dataField: 'isPopup',
                text: '¿Es anuncio principal?',
                formatter:(value)=>{
                    const isPopup = value ? 'Si' : 'No';
                    const color = value ? 'text-success font-bold' : '';

                    return <span className={color}>{isPopup}</span>;
                },
            },
        ];

        return(
            <Container fluid style={{overflowY:"scroll"}} className={'h-100'}>
                <Row>
                    <Col className='py-3 d-flex justify-content-between'>
                        <h5 className={'text-capitalize '}>Anuncios</h5>
                        <a href={'/ads/create'}>
                            <Button className={'ml-auto'}>Crear anuncio</Button>
                        </a>
                    </Col>
                </Row>

                <Row>
                    <Col className='pb-3'>
                        <NPIf condition={this.state.isLoading}>
                            <div className={'d-flex align-items-center justify-content-center'}>
                                <Spinner animation="grow" variant={"secondary"}/>
                            </div>
                            <NPElse>
                                <BootstrapTable keyField='_id'
                                                data={this.state.ads}
                                                columns={columns}
                                                noDataIndication={`No se encontraron anuncios`}
                                                bordered={false}
                                />
                                <NPPaginator
                                    numberOfPages={this.state.pages}
                                    onPageChanged={(p) => this.onPageChanged(p)} initialPage={this.state.currentPage}>
                                </NPPaginator>

                            </NPElse>
                        </NPIf>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withRouter(AdsTable);
